export const getDishImageUrl = (dish) => String(dish?.imageUrl ?? '').trim();

export const hasDishImageUrl = (url) => Boolean(String(url ?? '').trim());

export const getEventCoverImageFromApi = (event, fallbackUrl = '') =>
  event?.coverImageUrl ?? fallbackUrl;
